import React from 'react';
import { Link, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import Component from '../../components/Component';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Card, CardContent, Tab, Tabs, Typography } from '@mui/material';
import SeasonLeaderboardTab from './SeasonLeaderboardTab';
import DailyLeaderboardTab from './DailyLeaderboardTab';

function FanEnergyLeaderboard() {
  const location = useLocation();
  const tabValue = location.pathname.includes('/daily') ? 'daily' : 'season';

  return (
    <Component>
      <div className="page-body">
        <div className="container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                  <Button
                    component={Link}
                    to="/admin/fan-energy"
                    startIcon={<ArrowBackIcon />}
                    variant="outlined"
                    size="small"
                  >
                    Fan Energy dashboard
                  </Button>
                  <Typography variant="h5" component="h1">
                    FE Leaderboard
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  Inspect daily and season Fan Energy leaderboards for rewards and support.
                </Typography>
              </div>
            </div>
          </div>

          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
            <Tabs value={tabValue} aria-label="Fan Energy leaderboard tabs">
              <Tab
                label="Season"
                value="season"
                component={Link}
                to="/admin/fan-energy/leaderboard/season"
              />
              <Tab
                label="Daily"
                value="daily"
                component={Link}
                to="/admin/fan-energy/leaderboard/daily"
              />
            </Tabs>
          </Box>

          <Card>
            <CardContent>
              <Routes>
                <Route index element={<Navigate to="season" replace />} />
                <Route path="season" element={<SeasonLeaderboardTab />} />
                <Route path="daily" element={<DailyLeaderboardTab />} />
                <Route path="*" element={<Navigate to="season" replace />} />
              </Routes>
            </CardContent>
          </Card>
        </div>
      </div>
    </Component>
  );
}

export default FanEnergyLeaderboard;
